import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Modal, ModalCTA } from 'containers/misc'
import { Title } from 'components/layout'
import { FormData, Status, Button } from 'components/misc'
import { FormattedDate } from 'components/intl'

export default class AwardLeaderDetailModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    sendConfirmationEmail: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    data: {}
  }

  state = {
    displayConfirmBlock: false
  }

  render() {
    const { modalId, data } = this.props
    const { displayConfirmBlock } = this.state

    const showDateOfBirth = get(data, 'birthDate')
    const showMinAgeValue = !showDateOfBirth && get(data, 'minAgeValue')

    return (
      <Modal id={modalId} customActions>
        <Title h2 intlKey="moduleTitle.award_leader">
          Award Leader
        </Title>
        <div className="row">
          <div className="col-xs-6">
            <FormData label="First Name" intlKey="label.first_name">
              {get(data, 'firstName') ||
                get(data, 'awardLeader.person.firstName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Last Name" intlKey="label.last_name">
              {get(data, 'lastName') ||
                get(data, 'awardLeader.person.firstName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Email" intlKey="label.email">
              {get(data, 'email') || get(data, 'awardLeader.person.firstName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            {showMinAgeValue && <FormData label="Minimum age confirmation" intlKey="label.min_age_confirmation">
              {Math.floor(get(data, 'minAgeValue') / 12)}
            </FormData>}
            {showDateOfBirth && <FormData label="Birthday" intlKey="label.birthdate">
              {get(data, 'birthDate') ? (
                <FormattedDate value={data.birthDate} />
              ) : (
                get(data, 'awardLeader.person.firstName')
              )}
            </FormData>}
          </div>
          <div className="col-xs-6">
            <FormData label="Phone" intlKey="label.phone">
              {get(data, 'phoneNumber') ||
                get(data, 'awardLeader.person.phone')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Phone type" intlKey="label.phone_type">
              {get(data, 'phoneType.translationText') ||
                get(data, 'awardLeader.person.firstName')}
            </FormData>
          </div>

          <div className="col-xs-6">
            <FormData label="Organization" intlKey="label.organization">
              {get(data, 'awardLeader.organization.name')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Coordinator" intlKey="label.coordinator">
              <Status
                state={Boolean(get(data, 'isCoordinator'))}
                check
                inline
                noWaiting
              />
            </FormData>
          </div>
        </div>

        <Title h2 intlKey="moduleTitle.address">
          Address
        </Title>

        <div className="row">
          <div className="col-xs-6">
            <FormData label="Address Line 1" intlKey="label.addressLine1">
              {get(data, 'line1') ||
                get(data, 'awardLeader.person.address.line1') ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="City" intlKey="label.city">
              {get(data, 'city') ||
                get(data, 'awardLeader.person.address.city') ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Address Line 2" intlKey="label.addressLine2">
              {get(data, 'line2') ||
                get(data, 'awardLeader.person.address.line2') ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Post Code" intlKey="label.post_code">
              {get(data, 'zipCode') ||
                get(data, 'awardLeader.person.address.zipCode') ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Address Line 2" intlKey="label.state_province">
              {get(data, 'stateOrProvinceOrRegion') ||
                get(
                  data,
                  'awardLeader.person.address.stateOrProvinceOrRegion'
                ) ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Post Code" intlKey="label.country">
              {get(data, 'country.name') ||
                get(data, 'awardLeader.person.address.country.name') ||
                '---'}
            </FormData>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              intlKey="button.send_confirmation_email_again_question"
              secondary
              onClick={() =>
                this.setState({
                  displayConfirmBlock: true
                })
              }
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              type="button"
              intlKey="button.close"
              onClick={() => this.props.modal(null)}
            >
              Close
            </Button>
          </div>
        </div>
        {displayConfirmBlock && (
          <ModalCTA>
            <Title
              h2
              intlKey="moduleTitle.are_you_sure"
              className="text--center"
            >
              Are you sure?
            </Title>
            <div className="row">
              <div className="col-xs-6">
                <Button
                  type="button"
                  intlKey="button.close"
                  onClick={() => this.setState({ displayConfirmBlock: false })}
                  secondary
                >
                  Close
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <Button
                  type="button"
                  intlKey="button.send"
                  onClick={() => this.props.sendConfirmationEmail(data.id)}
                >
                  Send
                </Button>
              </div>
            </div>
          </ModalCTA>
        )}
      </Modal>
    )
  }
}
